import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { push } from 'connected-react-router'
import { notification } from 'redux/modules/app'
import { nextLevel as nextLevelApi } from 'redux/modules/api'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import { nextLevelScheme } from 'models'
import { getRegistrationInfo } from '../../../../redux/modules/api/participants'

function decorator() {
  return ComposedComponent => {
    @connect(
      ({ api, app }) => ({
        nextLevel: api.nextLevel,
        localeId: app.locale.id
      }),
      { ...nextLevelApi, notification, push, reset, checkEmail }
    )
    class NextLevel extends Component {
      static propTypes = {
        localeId: PropTypes.number.isRequired,
        paymentInitialization: PropTypes.func.isRequired,
        createParticipant: PropTypes.func.isRequired,
        getPaymentOptions: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        checkEmail: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        getRegistrationInfo: PropTypes.func.isRequired
      }

      state = {
        leaderId: null,
        initialized: false
      }

      handleGetPaymentOptions = params => this.props.getPaymentOptions(params)

      handleCheckEmail = params =>
        this.props.checkEmail(params).then(({ body }) => body || false)

      handlePaymentInitialization = fields =>
        this.props.paymentInitialization(
          nextLevelScheme(fields, this.props.localeId)
        )

      handleParticipantCreate = (code, fields) =>
        this.props
          .createParticipant(code, nextLevelScheme(fields, this.props.localeId))
          .catch(this.handleError)

      handleInitialize = () => this.setState({ initialized: true })

      handleError = err => {
        console.debug('error', err.body.userMessage)
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            leaderId={this.state.leaderId}
            initialized={this.state.initialized}
            onPaymentInitialization={this.handlePaymentInitialization}
            onGetPaymentOptions={this.handleGetPaymentOptions}
            createParticipant={this.handleParticipantCreate}
            onInitialize={this.handleInitialize}
            checkEmail={this.handleCheckEmail}
          />
        )
      }
    }
    return NextLevel
  }
}

export default decorator
